export default "__VITE_ASSET__BcFIkm7f__"